import React, { useState } from "react";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Progress } from "../components/ui/progress";
import { importCSV } from "../lib/api";

const example = `date,description,matter,task_code,duration_hours\n2025-06-01,Research memo,Acme v. Smith,Review docs,1.2\n2025-06-02,Client call,Acme v. Smith,,0.6\n2025-06-03,Internal meeting,Trademark Review,,0.3`;

export default function ImportPage(){
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);
  const [progress, setProgress] = useState(0);

  async function upload(){
    if (!file) return;
    setUploading(true); setResult(null); setProgress(0);
    const form = new FormData();
    form.append('file', file);
    try{
      const res = await importCSV(form, (e)=>{ if (e.total) setProgress(Math.round((e.loaded/e.total)*100)); });
      setResult({ ok: true, ...res });
    }catch(err){
      const detail = err?.response?.data?.detail;
      setResult({ error: detail || 'Upload failed' });
    }finally{
      setUploading(false);
    }
  }

  function downloadExample(){
    const blob = new Blob([example], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = 'hourslaw_import_example.csv'; a.click(); URL.revokeObjectURL(url);
  }

  return (
    <div className="mx-auto max-w-3xl px-4 py-10">
      <Card>
        <CardHeader>
          <CardTitle>Import CSV</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-sm">
          <p>CSV file must contain these columns:</p>
          <ol className="list-decimal pl-5 space-y-1 text-muted-foreground">
            <li>date (YYYY-MM-DD)</li>
            <li>description (text)</li>
            <li>matter (name; must match existing)</li>
            <li>task_code (optional; name; must match existing)</li>
            <li>duration_hours (decimal; e.g., 1.5 for 1.5 hours)</li>
          </ol>
          <p className="text-xs text-muted-foreground mt-2">
            <strong>Note:</strong> You can also use <code>duration_tenths</code> (integer) for backward compatibility.
          </p>

          <div className="rounded-md bg-secondary/40 p-3 text-xs font-mono whitespace-pre-wrap">{example}</div>
          <div className="flex items-center gap-2">
            <Button variant="secondary" onClick={downloadExample}>Download example CSV</Button>
            <label className="text-sm">
              <input type="file" accept=".csv,text/csv" onChange={(e)=>setFile(e.target.files?.[0]||null)} />
            </label>
            <Button onClick={upload} disabled={!file || uploading}>Upload</Button>
          </div>
          {uploading && <Progress value={progress} />}
          {result && (
            <div className="text-sm mt-2">
              {result.error ? (
                <div className="text-destructive">
                  <div className="font-medium">Import failed</div>
                  <pre className="mt-1 whitespace-pre-wrap text-xs">{JSON.stringify(result.error, null, 2)}</pre>
                </div>
              ) : (
                <span className="text-muted-foreground">Imported {result.imported} entries. No errors.</span>
              )}
            </div>
          )}
        </CardContent>
        <CardFooter />
      </Card>
    </div>
  );
}